import "echarts";
import ECharts, * as exported from "./index";

export default {
  ...ECharts,
  ...exported
};
